import styled from "styled-components/native";

import { Text3 } from "~/components/text";
import { spacers } from "~/styles/theme";

export const Description = styled(Text3)<{ hasMargin: boolean }>`
  line-height: 22px;
  margin-bottom: ${({ hasMargin }) => (hasMargin ? spacers.ss9 : spacers.ss6)};
  letter-spacing: 1px;
`;

export const ListButtonContainer = styled.View`
  margin-bottom: ${spacers.ss5};
`;
